import { enableExplodeIcon } from '../state/ui-store';

export const enableExplodeBttn = () => enableExplodeIcon();
